import { useTranslation } from '@/i18n';
import {
  Bottom,
  ListView,
  ListViewBody,
  ListViewLabel,
  Top,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from '../styles.module.scss';

const cx = classnames.bind(styles);

interface EDocMetadataSectionProps {
  eDocMetaProps: {
    dpi: string;
    pixelNumber: string;
    imageDepth: string;
  };
  leftRightRatio?: {
    left: { value: string };
    right: { value: string };
  };
}

export const EDocMetadataSection: FC<EDocMetadataSectionProps> = memo(
  ({
    eDocMetaProps,
    leftRightRatio = { left: { value: '35%' }, right: { value: '65%' } },
  }) => {
    const { t } = useTranslation();

    return (
      <div className={cx('edoc-section')}>
        <div className={cx('section-title')}>{t('e_doc_information')}</div>
        <ListView leftRightRatio={leftRightRatio}>
          <Top>
            <ListViewLabel>{t('dpi_label')}</ListViewLabel>
            <ListViewBody className={cx('list-view-body')}>
              {eDocMetaProps.dpi}
            </ListViewBody>
          </Top>
          <Top>
            <ListViewLabel>{t('pixel_number_label')}</ListViewLabel>
            <ListViewBody className={cx('list-view-body')}>
              {eDocMetaProps.pixelNumber}
            </ListViewBody>
          </Top>
          <Top>
            <ListViewLabel>{t('image_depth_label')}</ListViewLabel>
            <ListViewBody className={cx('list-view-body')}>
              {eDocMetaProps.imageDepth}
            </ListViewBody>
          </Top>
          <Bottom>
            <ListViewLabel>{t('timestamp')}</ListViewLabel>
            <ListViewBody className={cx('list-view-body')}>
              {t('timestamp_added')}
            </ListViewBody>
          </Bottom>
        </ListView>
      </div>
    );
  }
);

EDocMetadataSection.displayName = 'EDocMetadataSection';
